module.exports = __webpack_public_path__ + "static/media/Cannon.0044008f.png";